import { library } from '@fortawesome/fontawesome-svg-core';
import { faGithub, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faBriefcase, faCog, faSchool } from '@fortawesome/pro-solid-svg-icons';

library.add(faBriefcase, faCog, faGithub, faLinkedin, faSchool, faTwitter);

export default library;
